// SPDX-FileCopyrightText: 2026 Povl Filip Sonne-Frederiksen
//
// SPDX-License-Identifier: GPL-3.0-or-later

import type { ReactNode } from 'react';

import styles from './GroupCaseList.module.css';

export interface GroupCaseItem {
  id: string;
  name: string;
  /** Where the case opens. A plain link: opening a case is a page load. */
  href: string;
  /** What the share gives ("Redaktør"). */
  share: string;
  /** The viewer's own role in the case, when they have one. */
  mine?: string;
}

/** The cases shared with a group, each a link into the case. */
export function GroupCaseList({ items, empty, label }: { items: GroupCaseItem[]; empty?: ReactNode; label: string }) {
  if (items.length === 0) return <>{empty}</>;
  return (
    <ul className={styles.list} aria-label={label}>
      {items.map((item) => (
        <li key={item.id} className={styles.row}>
          <a className={styles.link} href={item.href}>
            <span className={styles.name}>{item.name}</span>
            <span className={`${styles.id} mono`}>{item.id}</span>
          </a>
          <span className={styles.meta}>
            <span className={styles.share}>Delt som {item.share}</span>
            {item.mine && <span className={styles.mine}>Din rolle: {item.mine}</span>}
          </span>
        </li>
      ))}
    </ul>
  );
}
